import { Group, Text } from "@mantine/core";

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <Group gap={8} align="center" wrap="nowrap">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id="moneyflux-logo" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#22c55e" />
            <stop offset="1" stopColor="#0ea5e9" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="url(#moneyflux-logo)" />
        <path
          d="M12 40c6 0 6-16 12-16s6 16 12 16 6-16 12-16"
          fill="none"
          stroke="#ffffff"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.9"
        />
        <text
          x="32"
          y="30"
          textAnchor="middle"
          fontFamily="Georgia, serif"
          fontSize="26"
          fontWeight="700"
          fill="#ffffff"
        >
          £
        </text>
      </svg>
      <Text fw={700} size="lg">
        Moneyflux
      </Text>
    </Group>
  );
}
